// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l6Fue","colMin":"styles_colMin__wZPdG"};